import Image from "next/image";

const ContactUsElement = ({ title, content, href, src }: { title: string; content: string; href: string; src:string; }) => {
  return (
    <div className="mb-4 bg-gray01 p-4 flex flex-col-2">
      <Image width={35} height={35} src={src} alt={title} className="w-auto"/>
      <div className="mx-4">
        <p className="font-bold text-lg">{title}</p>
        <a href={href} className="text-sm sm:text-xl">{content}</a>
      </div>
    </div>
  )
}
 
export default ContactUsElement